// Decodes a base64-encoded file (as returned by the API inside the JSON
// envelope, e.g. the serialization template) and triggers a browser download.
export function downloadBase64File(
  fileBase64: string,
  filename: string,
  contentType: string
): void {
  const bytes = Uint8Array.from(atob(fileBase64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: contentType });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}
